import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fodderFarming: {
    id: 'farmTypes.fodderFarming',
    defaultMessage: 'Fodder Farming',
    description: 'Fodder Farming farm type',
  },
  permanentCrops: {
    id: 'farmTypes.permanentCrops',
    defaultMessage: 'Permanent Crops',
    description: 'Permanent Crops farm type',
  },
  livestock: {
    id: 'farmTypes.livestock',
    defaultMessage: 'Livestock',
    description: 'Livestock farm type',
  },
  arable: {
    id: 'farmTypes.arable',
    defaultMessage: 'Arable',
    description: 'Arable farm type',
  },
  energyFarming: {
    id: 'farmTypes.energyFarming',
    defaultMessage: 'Energy Farming',
    description: 'Energy Farming farm type',
  },
  other: {
    id: 'farmTypes.other',
    defaultMessage: 'Other',
    description: 'Other farm type',
  },
  horticultureSpecialised: {
    id: 'farmTypes.horticultureSpecialised',
    defaultMessage: 'Horticulture/Specialised',
    description: 'Horticulture Specialised farm type',
  },
  mixedFarming: {
    id: 'farmTypes.mixedFarming',
    defaultMessage: 'Mixed Farming',
    description: 'Mixed Farming farm type',
  },
});

export default messages;
